import { gql } from '@apollo/client'

const createOrderArticle = gql`
  mutation createOrderArticle($idOrder: UUID!, $idArticle: UUID!) {
    createOrderArticle(
      input: {
        orderArticle: { idOrder: $idOrder, idArticle: $idArticle, quantity: 1 }
      }
    ) {
      orderArticle {
        id
      }
      orderByIdOrder {
        id
      }
    }
  }
`

export default createOrderArticle
